var _path, _g, _g2, _g3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreateTags(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 411 258",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.05 204.265C51.19 181.707 28.916-14.802 178.503 28.536 250.271 49.33 243.858 2.296 284.46 3.008c65.176 1.145 91.094 66.493 68.56 98.55-42.777 60.859-40.581 192.058-130.409 142.483-83.495-46.081-105.874-17.339-138.56-39.776Z",
    fill: "#F8F8FC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 105,
    y: 27,
    width: 256.46,
    height: 49.902,
    rx: 24.951,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M92 12h291v71H92z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m123.707 51.457 10.307 10.168c.327.315.763.49 1.217.49a1.754 1.754 0 0 0 1.268-.49l6.178-6.187a1.754 1.754 0 0 0 .372-1.989 1.735 1.735 0 0 0-.425-.574l-10.237-10.063-.044-.052a3.307 3.307 0 0 0-2.091-.875h-5.688a1.749 1.749 0 0 0-1.75 1.75v5.74c.044.777.36 1.515.893 2.082Zm3.045-4.305a1.316 1.316 0 0 1 .834-1.187 1.311 1.311 0 1 1-.834 1.187Z",
    fill: "#CC4CB3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M158 51.633a4.106 4.106 0 0 1 4.106-4.106h30.636a4.106 4.106 0 1 1 0 8.212h-30.636A4.106 4.106 0 0 1 158 51.633ZM207.587 51.633a4.106 4.106 0 0 1 4.105-4.106h125.811a4.106 4.106 0 0 1 0 8.212H211.692a4.105 4.105 0 0 1-4.105-4.106Z",
    fill: "#E7ACDB"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#d)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 94,
    width: 256.46,
    height: 49.902,
    rx: 24.951,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    d: "M36 79h269v71H36z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m67.707 118.457 10.308 10.168c.326.315.762.49 1.216.49a1.755 1.755 0 0 0 1.269-.49l6.177-6.186a1.756 1.756 0 0 0 .372-1.99 1.743 1.743 0 0 0-.425-.574l-10.237-10.063-.044-.052a3.306 3.306 0 0 0-2.091-.875h-5.688a1.75 1.75 0 0 0-1.75 1.75v5.74c.044.777.36 1.515.893 2.082Zm3.045-4.305a1.31 1.31 0 0 1 .834-1.187 1.317 1.317 0 0 1 1.418.306 1.313 1.313 0 1 1-2.252.881Z",
    fill: "#469DF1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102 118.633a4.106 4.106 0 0 1 4.106-4.106h30.636a4.106 4.106 0 0 1 0 8.212h-30.636a4.106 4.106 0 0 1-4.106-4.106ZM151.587 118.633a4.106 4.106 0 0 1 4.105-4.106h125.811a4.107 4.107 0 0 1 0 8.212H155.692a4.105 4.105 0 0 1-4.105-4.106Z",
    fill: "#92C5F7"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#g)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#h)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 161,
    width: 256.46,
    height: 49.902,
    rx: 24.951,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#i)",
    d: "M87 146h269v71H87z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m118.707 185.457 10.307 10.168c.327.315.763.49 1.217.49a1.758 1.758 0 0 0 1.268-.49l6.178-6.186a1.759 1.759 0 0 0 .533-1.294 1.75 1.75 0 0 0-.586-1.27l-10.237-10.063-.044-.052a3.306 3.306 0 0 0-2.091-.875h-5.688a1.75 1.75 0 0 0-1.75 1.75v5.74c.044.777.36 1.515.893 2.082Zm3.045-4.305a1.314 1.314 0 0 1 2.252-.881 1.316 1.316 0 0 1 .269 1.426 1.311 1.311 0 0 1-2.521-.545Z",
    fill: "#35B6BB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M153 185.633a4.106 4.106 0 0 1 4.106-4.106h30.636a4.106 4.106 0 0 1 0 8.212h-30.636a4.106 4.106 0 0 1-4.106-4.106ZM202.587 185.633a4.106 4.106 0 0 1 4.105-4.106h125.811a4.107 4.107 0 0 1 0 8.212H206.692a4.105 4.105 0 0 1-4.105-4.106Z",
    fill: "#6CD2D5"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 121.65,
    y1: 56.072,
    x2: 382.541,
    y2: 73.097,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0CBE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0CBE9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 50.5,
    y1: 128,
    x2: 354.5,
    y2: 127,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEEDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEEDFD",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 98,
    y1: 194.5,
    x2: 375.5,
    y2: 196,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ACE5E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ACE5E7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 105,
    y: 27,
    width: 256.46,
    height: 49.902,
    rx: 24.951,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 94,
    width: 256.46,
    height: 49.902,
    rx: 24.951,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "h"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 161,
    width: 256.46,
    height: 49.902,
    rx: 24.951,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 92.367,
    y: 27,
    width: 281.728,
    height: 75.169,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 3.79,
    in: "SourceAlpha",
    result: "effect1_dropShadow_2433_29823"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.053
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.158
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2433_29823"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 3.158,
    in: "SourceAlpha",
    result: "effect2_dropShadow_2433_29823"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 12.633
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.896
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_2433_29823",
    result: "effect2_dropShadow_2433_29823"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect2_dropShadow_2433_29823",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "d",
    x: 36.367,
    y: 94,
    width: 281.728,
    height: 75.169,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 3.79,
    in: "SourceAlpha",
    result: "effect1_dropShadow_2433_29823"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.053
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.158
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2433_29823"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 3.158,
    in: "SourceAlpha",
    result: "effect2_dropShadow_2433_29823"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 12.633
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.896
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_2433_29823",
    result: "effect2_dropShadow_2433_29823"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect2_dropShadow_2433_29823",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "g",
    x: 87.367,
    y: 161,
    width: 281.728,
    height: 75.169,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 3.79,
    in: "SourceAlpha",
    result: "effect1_dropShadow_2433_29823"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.053
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.158
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2433_29823"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 3.158,
    in: "SourceAlpha",
    result: "effect2_dropShadow_2433_29823"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 12.633
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.896
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_2433_29823",
    result: "effect2_dropShadow_2433_29823"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect2_dropShadow_2433_29823",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateTags);
export default __webpack_public_path__ + "static/media/createTags.38b1ae1a939587e9f526e606ec17db96.svg";
export { ForwardRef as ReactComponent };